import React from 'react'
import { Select, SelectProps } from '@shared/Form/Select'
import { useTranslation } from 'react-i18next'
import { useAllParkingLot } from '@services/session'

type Props = {
  isShowAll?: boolean
  isShowId?: boolean
  queryId?: number
} & SelectProps

export default function StandSelect({
  isShowAll = false,
  isShowId = false,
  queryId,
  ...props
}: Props) {
  const { t } = useTranslation()

  const q = React.useMemo(
    () => ({
      sessionId: queryId,
    }),
    [queryId]
  )

  const { dataSource } = useAllParkingLot({ ...q })

  return (
    <Select {...props}>
      {isShowAll && (
        <Select.Option key="all" value="">
          {t('common:all')}
        </Select.Option>
      )}
      {dataSource?.content.map(x => (
        <Select.Option key={x.id} value={x.id}>
          {isShowId ? `${x?.id}/` : ''}
          {x.name}
        </Select.Option>
      ))}
    </Select>
  )
}
